import { render } from "./Lock.vue?vue&type=template&id=0d4b7f27"
import script from "./Lock.vue?vue&type=script&lang=js"
export * from "./Lock.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Lock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d4b7f27"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d4b7f27', __exports__)) {
    api.reload('0d4b7f27', __exports__)
  }
  
  module.hot.accept("./Lock.vue?vue&type=template&id=0d4b7f27", () => {
    api.rerender('0d4b7f27', render)
  })

}


export default __exports__